module.exports = __webpack_public_path__ + "static/media/interviewbit.fc7bf191.PNG";